import { pki } from 'node-forge';
export const parsePemAndGetValidityPeriod = (pemString) => {
    return pki.certificateFromPem(pemString).validity;
};
